// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';

const ConfigReportList = lazy(
  () => import('pages/reports/configReport/configReportList')
);

const ConfigReportRoute = (
  <Route path={routeName.configReport}>
    <Route
      index
      element={
        <PrivateRoute name={[PrivateRouteConst.REPORT_CONFIG_VIEW]}>
          <Suspense fallback={<Loading />}>
            <ConfigReportList />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default ConfigReportRoute;
